module.exports = __webpack_public_path__ + "img/cursor.39897242.png";